import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../assets/logo.js';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`Navbar_navbar__Y5E4F ${scrolled ? 'Navbar_scrolled__prYhZ' : ''}`}>
      <div className="container Navbar_navContainer__waYXh">
        <Link to="/" className="Navbar_logo__f5MT3" onClick={closeMenu}>
          <span className="Navbar_logoMark__lZhlT">
            <img src={logo} alt="" aria-hidden="true" />
          </span>
          <span>Vitae Careers</span>
        </Link>
        <div className="Navbar_desktopMenu__VpS73">
          <div className="Navbar_navLinks__10se4">
            <NavLink
              to="/"
              end
              className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
            >
              About Us
            </NavLink>
            <NavLink
              to="/how-it-works"
              className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
            >
              Why It Matters
            </NavLink>
            <NavLink
              to="/services"
              className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
            >
              Career Assessment
            </NavLink>
            <NavLink
              to="/blog"
              className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
            >
              Blog
            </NavLink>
            <NavLink
              to="/gallery"
              className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
            >
              Gallery
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
            >
              Contact Us
            </NavLink>
          </div>
          <a
            href="https://vitaecareer.edumilestones.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Book Assessment
          </a>
        </div>
        <button
          className="Navbar_mobileToggle__qJGwt"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
      <div className={`Navbar_mobileMenu__QpD4E ${menuOpen ? 'Navbar_mobileMenuOpen__yqY0G' : ''}`}>
        <div className="Navbar_mobileNavLinks__Uj-Z+">
          <NavLink
            to="/"
            end
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
          >
            About Us
          </NavLink>
          <NavLink
            to="/how-it-works"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
          >
            Why It Matters
          </NavLink>
          <NavLink
            to="/services"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
          >
            Career Assessment
          </NavLink>
          <NavLink
            to="/blog"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
          >
            Blog
          </NavLink>
          <NavLink
            to="/gallery"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
          >
            Gallery
          </NavLink>
          <NavLink
            to="/contact"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? 'Navbar_activeLink__21Z2m' : 'Navbar_link__YyyhS')}
          >
            Contact Us
          </NavLink>
          <a
            href="https://vitaecareer.edumilestones.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ marginTop: '1rem' }}
          >
            Book Assessment
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
